import React, { useState, useRef } from 'react';
import AdminHeader from './AdminHeader';
import ChallengeManagement from './ChallengeManagement';
import './Assessments.css';

function Assessments({ onNavigate, currentView }) {
  const [activeTab, setActiveTab] = useState('challenges');
  const challengeManagementRef = useRef(null);

  const handleCreateChallenge = () => {
    // Trigger create challenge in ChallengeManagement component
    if (challengeManagementRef.current && challengeManagementRef.current.handleCreate) {
      challengeManagementRef.current.handleCreate();
    }
  };

  return (
    <>
      <AdminHeader currentView={currentView} onNavigate={onNavigate} />
      <div className="assessments-container">
        <div className="assessments-header">
          <div className="header-content">
            <div>
              <h1>Assessments</h1>
              <p className="assessments-subtitle">Manage interviews, challenges, and question banks</p>
            </div>
            {activeTab === 'challenges' && (
              <button className="cyber-btn success" onClick={handleCreateChallenge}>
                + Create Challenge
              </button>
            )}
          </div>
        </div>

        <div className="assessments-tabs">
          <button
            className={`tab-button ${activeTab === 'interviews' ? 'active' : ''}`}
            onClick={() => setActiveTab('interviews')}
          >
            Interviews
          </button>
          <button
            className={`tab-button ${activeTab === 'challenges' ? 'active' : ''}`}
            onClick={() => setActiveTab('challenges')}
          >
            Challenges
          </button>
        </div>

        <div className="assessments-content">
          {activeTab === 'interviews' && (
            <div className="coming-soon">
              <h2>Interview Management</h2>
              <p>Schedule and manage technical interviews</p>
              <span className="badge">Coming Soon</span>
            </div>
          )}
          {activeTab === 'challenges' && (
            <ChallengeManagement
              ref={challengeManagementRef}
              onNavigate={onNavigate}
              currentView="assessments"
              embedded={true}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Assessments;
